import { CONSTANTS } from '../Constants/Constant'
import { getLocalStorage } from './Storage'

export const PERMISSIONS = {
  ROLE_USER: 'BLITZ_MODULE.ROLE_AND_USER_MANAGEMENT',
  AUDIT_TRAILS: 'BLITZ_MODULE.AUDIT_TRAILS',
  REPORTING: 'BLITZ_MODULE.REPORTING',
  MANAGE_CONTENT: 'BLITZ_MODULE.MANAGE_CONTENT',
  META_MASTER: 'BLITZ_MODULE.META_MASTER',
  MANAGE_POLICIES: 'BLITZ_MODULE.MANAGE_POLICIES',
  BULK_UPDATE: 'BLITZ_MODULE.BULK_UPDATE',
  BULK_TRANSCODING: 'BLITZ_MODULE.BULK_RE_TRANSCODING',
  BULK_OPERATIONS_REPORTS: 'BLITZ_MODULE.BULK_OPERATIONS_REPORTS',
  BULK_STATE_CHANGE: 'BLITZ_MODULE.BULK_STATE_CHANGE',
  INTERACTIVE_BULK_UPDATE: 'BLITZ_MODULE.INTERACTIVE_BULK_UPDATE',
  INBOUND_SERVICE: 'BLITZ_MODULE.INBOUND_SERVICE',
  META_CAT_DESCRIPTIVE_METADATA: 'META_CATEGORIES.DESCRIPTIVE_METADATA',
  META_CAT_RIGHTS_AND_AVAILABILITY: 'META_CATEGORIES.RIGHTS_AND_AVAILABILITY',
  META_CAT_SEO_METADATA: 'META_CATEGORIES.SEO_METADATA',
  META_CAT_ADVERTISEMENT_METADATA: 'META_CATEGORIES.ADVERTISEMENT_METADATA',
  META_CAT_BUSINESS_RULES: 'META_CATEGORIES.BUSINESS_RULES',
  META_CAT_TECHNICAL_METADATA: 'META_CATEGORIES.TECHNICAL_METADATA',
  META_CAT_CONTENT_MEDIA_IMAGE: 'META_CATEGORIES.CONTENT_MEDIA_IMAGE',
  META_CAT_CONTENT_MEDIA_VIDEO: 'META_CATEGORIES.CONTENT_MEDIA_VIDEO',
  META_CAT_SPORTS_METADATA: 'META_CATEGORIES.SPORTS_METADATA',
  META_CAT_MISCELLANEOUS_METADATA: 'META_CATEGORIES.MISCELLANEOUS_METADATA',
  META_CAT_CHECKLIST: 'META_CATEGORIES.CHECKLIST',

  TOLL_DESCRIPTIVE_METADATA: 'TOLLGATES.DESCRIPTIVE_METADATA',
  TOLL_RIGHTS_AND_AVAILABILITY: 'TOLLGATES.RIGHTS_AND_AVAILABILITY',
  TOLL_SEO_METADATA: 'TOLLGATES.SEO_METADATA',
  TOLL_ADVERTISEMENT_METADATA: 'TOLLGATES.ADVERTISEMENT_METADATA',
  TOLL_BUSINESS_RULES: 'TOLLGATES.BUSINESS_RULES',
  TOLL_TECHNICAL_METADATA: 'TOLLGATES.TECHNICAL_METADATA',
  TOLL_CONTENT_MEDIA_IMAGE: 'TOLLGATES.CONTENT_MEDIA_IMAGE',
  TOLL_SPORTS_METADATA: 'TOLLGATES.SPORTS_METADATA',
  TOLL_MISCELLANEOUS_METADATA: 'TOLLGATES.MISCELLANEOUS_METADATA',
  TOLL_CHECKLIST: 'TOLLGATES.CHECKLIST',
  TOLL_QC_PROCESS: 'TOLLGATES.QC_PROCESS',
  TOLL_PUBLISHING: 'TOLLGATES.PUBLISHING',
  TOLL_RIGHTS_EXPIRED: 'TOLLGATES.RIGHTS_EXPIRED',
  TOLL_DEPUBLISH: 'TOLLGATES.DEPUBLISH',

  META_MASTER_ATTRIBUTE_REPO: 'META_MASTER.ATTRIBUTES_REPO',
  META_MASTER_ASSET_DEFINITION: 'META_MASTER.ASSET_DEFINITION',
  META_MASTER_MASTERS: 'META_MASTER.MASTERS',
  META_MASTER_MANAGE_TIPS: 'META_MASTER.MANAGE_TIPS',
  MANAGE_POLICIES_GEO_POLICY: 'MANAGE_POLICIES.GEO_POLICY',
  MANAGE_POLICIES_ENTITLEMENT_CONTROL_POLICY: 'MANAGE_POLICIES.ENTITLEMENT_POLICY',
  MANAGE_POLICIES_LANGUAGE_CONTROL_POLICY: 'MANAGE_POLICIES.LANGUAGE_CONTROL_POLICY',
  PARTNER_MANAGEMENT: 'PARTNER_MANAGEMENT',
  MANAGE_FILE: 'BLITZ_MODULE.MANAGE_FILE',

  NOTIFICATION_PREFERENCES: 'NOTIFICATION_PREFERENCES',
  NOTIF_PREF_ASSET_PUBLISH: 'NOTIFICATION_PREFERENCES.ASSET_PUBLISH',
  NOTIF_PREF_ASSET_DEPUBLISH: 'NOTIFICATION_PREFERENCES.ASSET_DEPUBLISH',
  NOTIF_PREF_TRANSCODING_COMPLETED: 'NOTIFICATION_PREFERENCES.TRANSCODING_COMPLETED',
  NOTIF_PREF_TRANSCODING_FAILED: 'NOTIFICATION_PREFERENCES.TRANSCODING_FAILED',
  NOTIF_PREF_FETCH_VALIDATION_FAILED: 'NOTIFICATION_PREFERENCES.FETCH_VALIDATION_FAILED',
  NOTIF_PREF_PREVIEW_COMPLETED: 'NOTIFICATION_PREFERENCES.PREVIEW_COMPLETED',
  NOTIF_PREF_PREVIEW_FAILED: 'NOTIFICATION_PREFERENCES.PREVIEW_FAILED',
  NOTIF_PREF_PUBLISHING_FAILED: 'NOTIFICATION_PREFERENCES.PUBLISHING_FAILED',
  NOTIF_PREF_BULK_UPDATED: 'NOTIFICATION_PREFERENCES.BULK_UPDATED',
  NOTIF_PREF_BULK_STATE_CHANGE_EVENT: 'NOTIFICATION_PREFERENCES.BULK_STATE_CHANGE_EVENT',
  NOTIF_PREF_BULK_INTERACTIVE_EVENT: 'NOTIFICATION_PREFERENCES.BULK_INTERACTIVE_EVENT',
  NOTIF_PREF_INGESTION_FAILED: 'NOTIFICATION_PREFERENCES.INGESTION_FAILED',
  NOTIF_PREF_GEO_POLICY_FAILED: 'NOTIFICATION_PREFERENCES.GEO_POLICY_FAILED',
  NOTIF_PREF_ENTITLEMENT_CHANGE_FAILED: 'NOTIFICATION_PREFERENCES.ENTITLEMENT_CHANGE_FAILED',
  NOTIF_PREF_URL_GENERATION: 'NOTIFICATION_PREFERENCES.URL_GENERATION',
  NOTIF_PREF_ASSET_GROUP_VALIDATED_SUCCESSFULLY:
    'NOTIFICATION_PREFERENCES.ASSET_GROUP_VALIDATED_SUCCESSFULLY',
  NOTIF_PREF_ASSET_GROUP_VALIDATION_FAILED:
    'NOTIFICATION_PREFERENCES.ASSET_GROUP_VALIDATION_FAILED',
  NOTIF_PREF_ASSET_GROUP_URL_GENERATED_SUCCESSFULLY:
    'NOTIFICATION_PREFERENCES.ASSET_GROUP_URL_GENERATED_SUCCESSFULLY',
  NOTIF_PREF_ASSET_GROUP_URL_GENERATION_FAILED:
    'NOTIFICATION_PREFERENCES.ASSET_GROUP_URL_GENERATION_FAILED',

  CONTENT_NOTIFICATION_PREFERENCES: 'CONTENT_NOTIFICATION_PREFERENCES',
  CONTENT_NOTIF_TV_SHOW: 'CONTENT_NOTIFICATION_PREFERENCES.TV_SHOW',
  CONTENT_NOTIF_MOVIES: 'CONTENT_NOTIFICATION_PREFERENCES.MOVIES',
  CONTENT_NOTIF_SPORTS: 'CONTENT_NOTIFICATION_PREFERENCES.SPORTS',
  CONTENT_NOTIF_ORIGINALS: 'CONTENT_NOTIFICATION_PREFERENCES.ORIGINALS',
  CONTENT_NOTIF_NON_VOD_ASSETS: 'CONTENT_NOTIFICATION_PREFERENCES.NON_VOD_ASSETS',
  CONTENT_NOTIF_INDEPENDENT_VOD_ASSETS: 'CONTENT_NOTIFICATION_PREFERENCES.INDEPENDENT_VOD_ASSETS',

  REPORTS_MODULE: 'REPORTS_MODULE',
  REPORTS_MODULE_CONTENT_INGESTION_REPORT: 'REPORTS_MODULE.CONTENT_INGESTION_REPORT',
  REPORTS_MODULE_PUBLISHING_MONITORING_REPORT: 'REPORTS_MODULE.PUBLISHING_MONITORING_REPORT',
  REPORTS_MODULE_BULK_OPERATIONS_REPORT: 'REPORTS_MODULE.BULK_OPERATIONS_REPORT',
  REPORTS_MODULE_SNP_REVIEW_REPORT: 'REPORTS_MODULE.SNP_REVIEW_REPORT',
}

export const PERMISSION_TYPE = {
  CAN_ACCESS: 'canAccess',
  CAN_READ: 'canRead',
  CAN_WRITE: 'canWrite',
  CAN_SKIP_VALIDATION: 'canSkipValidation',
  CAN_STATE_TRANSITION: 'canStateTransition',
}

export const checkPermission = (permission: string, permissionTypes: string[]): boolean => {
  const permissions = getLocalStorage(CONSTANTS.LOCAL_KEYS.ROLE_DATA) as any

  if (permission && permissions && permissions.length) {
    const [moduleKey, subModuleKey] = permission.split('.')

    const module = permissions.find((item: any) => item.key === moduleKey)

    if (module) {
      const submodulePermissions = module.submodules || []
      const submodule = submodulePermissions.find((sub: any) => sub.key === subModuleKey)

      if (submodule && submodule.permission) {
        return permissionTypes.every((type) => submodule.permission[type])
      }
    }
  }

  return false
}

export const checkAnyMetaWritePermission = () => {
  const permissions = getLocalStorage(CONSTANTS.LOCAL_KEYS.ROLE_DATA) as any
  if (permissions && permissions.length) {
    const module = permissions.find((item: any) => item.key === 'META_CATEGORIES')
    if (module) {
      const isPermisson = (module.submodules || []).find(
        (item: any) => item.permission[PERMISSION_TYPE.CAN_WRITE],
      )
      if (isPermisson) {
        return true
      }
    }
  }
  return false
}

export const getNotifOnScreenPermissions = () => {
  const permissions = getLocalStorage(CONSTANTS.LOCAL_KEYS.ROLE_DATA) as any
  if (permissions && permissions.length) {
    const module = permissions.find((item: any) => item.key === 'NOTIFICATION_PREFERENCES')
    if (module && module.submodules && module.submodules.length) {
      return module.submodules.reduce((acc: any, submodule: any) => {
        acc[submodule.key] = submodule.permission?.onScreenNotification || false
        return acc
      }, {})
    }
  }
  return {}
}
